import { SelectInput, TextInput } from "react-admin";
import { SADARAT_GENDER_CHOICES } from "@/utils/sadarat-gender";
import SadaratItsPickerInput from "./SadaratItsPickerInput";

export function SadaratFormFields() {
  return (
    <>
      <SadaratItsPickerInput />
      <SelectInput
        source="gender"
        label="Gender"
        choices={SADARAT_GENDER_CHOICES}
        isRequired
        fullWidth
        helperText="Required — auto-filled from the directory Gender when ITS is found"
      />
      <TextInput
        source="name"
        fullWidth
        isRequired
        helperText="Auto-filled from the directory when ITS is found; otherwise enter manually"
      />
      <TextInput source="mobile" fullWidth />
    </>
  );
}
